import React from "react";


function SidebarDisclosures(props) {

     return (
         <div className="mt-5 is-flex is-flex-direction-column is-justify-content-center is-align-items-center">
             <p className="is-size-7 has-text-white-bis is-italic">We don't sell your data.</p>
             <p className="is-size-7 has-text-white-bis is-italic"><a href="http://blog.cleanfi.com/privacy-disclosure/" target="_blank" rel="noreferrer">Privacy Policy</a></p>
         </div>
     )
}

export default SidebarDisclosures;